module.exports = __webpack_public_path__ + "img/logo_paces@2x.2ea3dad3.png";